module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div>\n	<div>\n		Добавлено:\n		<div name=\"thumbs\"></div>\n		<div name=\"list\"></div>\n		<label>\n			<input type=\"file\" ")
    ; __append( Html.attributes(attributes) )
    ; __append(" />\n		</label>\n	</div>\n</div>\n")
  }
  return __output.join("");

}